import { render } from "./AutoShipModify.vue?vue&type=template&id=4ff8540f"
import script from "./AutoShipModify.vue?vue&type=script&lang=js"
export * from "./AutoShipModify.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__